"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUserCustom = void 0;
var _alloyProvider = require("@adsk/alloy-provider");
var _react = require("react");
/**
 /* Package.json is outside of our Typescript rootDir therefore, we use require, instead of import.
 /* If we change the rootDir to include this file, it would change the output of es folder and break our consumers
 */
// eslint-disable-next-line @typescript-eslint/no-var-requires
const accIssuesPackage = require("../../../../package.json");
const useUserCustom = () => {
  const accountId = (0, _alloyProvider.useCurrentAccountId)();
  return (0, _react.useMemo)(() => {
    var _path$1$toLowerCase, _path$, _path$2$toLowerCase, _path$2, _version$match$slice$, _version$match;
    const hostParts = window.location.host.split(".");
    const path = !["revit-issues", "navisworks-issues"].some(module => window.location.host.includes(module)) ?
    // https://local.acc-qa.autodesk.com:3001/build/issues
    window.location.pathname.split("/") :
    // https://revit-issues.b360-qa.autodesk.com/
    [undefined, hostParts.at(-4), hostParts.at(-4)];
    const [hostingModuleName, hostingTabName] = [(_path$1$toLowerCase = path === null || path === void 0 || (_path$ = path[1]) === null || _path$ === void 0 ? void 0 : _path$.toLowerCase()) !== null && _path$1$toLowerCase !== void 0 ? _path$1$toLowerCase : "", (_path$2$toLowerCase = path === null || path === void 0 || (_path$2 = path[2]) === null || _path$2 === void 0 ? void 0 : _path$2.toLowerCase()) !== null && _path$2$toLowerCase !== void 0 ? _path$2$toLowerCase : ""];
    const version = accIssuesPackage.version;
    const [major, minor, patch] = (_version$match$slice$ = version === null || version === void 0 || (_version$match = version.match(/^(\d+)\.(\d+)\.(\d+)[^\d]?.*$/)) === null || _version$match === void 0 ? void 0 : _version$match.slice(1).map(x => Number(x))) !== null && _version$match$slice$ !== void 0 ? _version$match$slice$ : [];
    return {
      hostingModuleName,
      hostingTabName,
      version,
      major,
      minor,
      patch,
      accountId
    };
  }, [accountId]);
};
exports.useUserCustom = useUserCustom;
//# sourceMappingURL=useLDUserCustom.js.map